/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: unknown; output: unknown; }
  Base64: { input: unknown; output: unknown; }
  DateTime: { input: unknown; output: unknown; }
  Upload: { input: unknown; output: unknown; }
};

export type AnswerFeedbackKmRequest = {
  answer: Scalars['Int']['input'];
  question_id: Scalars['String']['input'];
};

export type AnswerListFeedbackKmRequest = {
  answer: Array<AnswerFeedbackKmRequest>;
  tutorial_id: Scalars['String']['input'];
};

export type AnswerListFeedbackKmResponse = {
  success: Scalars['Boolean']['output'];
};

export type AnswerListQuizChapterRequest = {
  answer: Array<AnswerQuizChapterRequest>;
  chapter_id: Scalars['String']['input'];
  packages: Scalars['String']['input'];
};

export type AnswerListQuizChapterResponse = {
  condition: Scalars['String']['output'];
  min_score: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  total_benar: Scalars['Int']['output'];
  total_salah: Scalars['Int']['output'];
};

export type AnswerListQuizTutorialRequest = {
  answer: Array<AnswerQuizTutorialRequest>;
  packages: Scalars['String']['input'];
  tutorial_id: Scalars['String']['input'];
};

export type AnswerListQuizTutorialResponse = {
  condition: Scalars['String']['output'];
  min_score: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  total_benar: Scalars['Int']['output'];
  total_salah: Scalars['Int']['output'];
};

export type AnswerQuizChapterRequest = {
  answers: Array<Scalars['String']['input']>;
  question_id: Scalars['String']['input'];
};

export type AnswerQuizChapterResponse = {
  explanation?: Maybe<Scalars['String']['output']>;
  is_correct: Scalars['Boolean']['output'];
};

export type AnswerQuizTutorialRequest = {
  answers: Array<Scalars['String']['input']>;
  question_id: Scalars['String']['input'];
};

export type AnswerSingleQuizChapterRequest = {
  answer: AnswerQuizChapterRequest;
  chapter_id: Scalars['String']['input'];
};

export type AnswerTestQuizInput = {
  answer_id: Scalars['Int']['input'];
  question_id: Scalars['Int']['input'];
};

export type AnswerTestQuizInputRequest = {
  answers: Array<AnswerTestQuizInput>;
  track_id: Scalars['String']['input'];
};

export type AnswerTestQuizResponse = {
  condition: Scalars['Boolean']['output'];
  min_score: Scalars['Int']['output'];
  score: Scalars['String']['output'];
  total_right_answer: Scalars['Int']['output'];
  total_wrong_answer: Scalars['Int']['output'];
};

export type AuthGetProfileResponse = {
  bitpoin: Scalars['String']['output'];
  city?: Maybe<City>;
  is_need_update_profile: Scalars['Boolean']['output'];
  kampus_merdeka: Scalars['Boolean']['output'];
  profile: User;
  province?: Maybe<Province>;
};

export type Benefits = {
  benefit: Scalars['Float']['output'];
  total_transactions: Scalars['Float']['output'];
};

export type BitpoinHistory = {
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  note_type_poin_id?: Maybe<Scalars['String']['output']>;
  poin?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type_additional?: Maybe<Scalars['String']['output']>;
  type_poin?: Maybe<Scalars['String']['output']>;
  type_poin_id?: Maybe<Scalars['String']['output']>;
  type_reduction?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type BitpoinHistoryWithPagination = {
  data: Array<BitpoinHistory>;
  next_page: Scalars['Int']['output'];
  previous_page: Scalars['Int']['output'];
  total_page: Scalars['Int']['output'];
};

export type BitpoinSortBy =
  | 'BitpoinLatest'
  | 'BitpoinNewest'
  | 'BitpoinTypePoin';

export type CallbackFrRequest = {
  private_code: Scalars['String']['input'];
};

export type CallbackFrResponse = {
  url: Scalars['String']['output'];
};

export type Certificate = {
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  expired?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  nameCertifTemp?: Maybe<Scalars['String']['output']>;
  numbCertificate: Scalars['String']['output'];
  published?: Maybe<Scalars['String']['output']>;
  trackID: Scalars['ID']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  urlQR: Scalars['String']['output'];
  userID: Scalars['ID']['output'];
};

export type CertificateKmPublish = {
  publish: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type CertificateModal = {
  activity_id: Scalars['String']['output'];
  certificate_description: Scalars['String']['output'];
  certificate_number: Scalars['String']['output'];
  program_period: Scalars['String']['output'];
  published_at: Scalars['String']['output'];
  student_name: Scalars['String']['output'];
  study_program: Scalars['String']['output'];
  total_score: Scalars['String']['output'];
  university: Scalars['String']['output'];
};

export type CertificateType =
  | 'Kelulusan'
  | 'Kompetensi'
  | 'Penyelesaian';

export type Chapter = {
  chapter_type: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  duration_quiz_countdown?: Maybe<Scalars['Int']['output']>;
  guide?: Maybe<Scalars['String']['output']>;
  icon_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_new: Scalars['Int']['output'];
  is_premium: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_quiz_count?: Maybe<Scalars['Int']['output']>;
  tutorial_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  video_duration?: Maybe<Scalars['Int']['output']>;
};

export type CheckAnswerLessonSplRequest = {
  answer: Scalars['String']['input'];
  lesson_id: Scalars['String']['input'];
};

export type CheckAnswerLessonSplResponse = {
  status: Scalars['Boolean']['output'];
};

export type CheckCodeRequest = {
  code: Scalars['String']['input'];
};

export type CheckCodeResponse = {
  attendance_status: Scalars['Int']['output'];
  course_code: Scalars['String']['output'];
  course_learning_method: Scalars['String']['output'];
  course_type: Scalars['Int']['output'];
  course_type_label: Scalars['String']['output'];
  dp_platform: Scalars['String']['output'];
  invoice_code: Scalars['String']['output'];
  is_online_attendance: Scalars['Boolean']['output'];
  redeem_at: Scalars['String']['output'];
  redeem_code: Scalars['String']['output'];
  schedule_code: Scalars['String']['output'];
  schedule_start_end: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
};

export type ChoosePblProjectKmRequest = {
  id: Scalars['String']['input'];
};

export type ChoosePblProjectKmResponse = {
  success: Scalars['Boolean']['output'];
};

export type City = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  province_id: Scalars['String']['output'];
};

export type DetailChapterFromDetailTutorial = {
  attempt?: Maybe<Scalars['Int']['output']>;
  chapter_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  duration_quiz_countdown?: Maybe<Scalars['Int']['output']>;
  guide?: Maybe<Scalars['String']['output']>;
  icon_url: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_new: Scalars['Int']['output'];
  is_premium: Scalars['Int']['output'];
  lesson_video_count: Scalars['Int']['output'];
  quiz_score?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  solved_lesson_count: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_lesson_count: Scalars['Int']['output'];
  total_quiz_count?: Maybe<Scalars['Int']['output']>;
  tutorial_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  video_duration?: Maybe<Scalars['Int']['output']>;
};

export type DetailChapterFromDetailTutorialKm = {
  attempt?: Maybe<Scalars['Int']['output']>;
  chapter_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  duration_quiz_countdown?: Maybe<Scalars['Int']['output']>;
  guide?: Maybe<Scalars['String']['output']>;
  icon_url: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_new: Scalars['Int']['output'];
  is_premium: Scalars['Int']['output'];
  lesson_video_count: Scalars['Int']['output'];
  quiz_score?: Maybe<Scalars['Int']['output']>;
  quiz_status?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  solved_lesson_count: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_lesson_count: Scalars['Int']['output'];
  total_quiz_count?: Maybe<Scalars['Int']['output']>;
  tutorial_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  video_duration?: Maybe<Scalars['Int']['output']>;
  webinar?: Maybe<GetWebinarStatusEntity>;
};

export type DetailChapterResponse = {
  created_at: Scalars['DateTime']['output'];
  have_quiz: Scalars['Boolean']['output'];
  have_quiz_tutorial: Scalars['Boolean']['output'];
  icon_url: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_chapter_available: Scalars['Boolean']['output'];
  is_new: Scalars['Int']['output'];
  is_premium: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  solved_lesson_count: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tutorial: Tutorial;
  tutorial_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type DetailPblProjectKmResponse = {
  already_choose: Scalars['Boolean']['output'];
  is_leader: Scalars['Boolean']['output'];
  is_selected: Scalars['Boolean']['output'];
  pbl_company_profile?: Maybe<PblCompanyProfileDetailResponse>;
  pbl_project_km: PblProjectKmDetailResponse;
  pbl_team?: Maybe<PblTeamDetailResponse>;
  pbl_team_score?: Maybe<PblTeamScoreDetailResponse>;
  tag: Scalars['String']['output'];
};

export type DetailQuizFromDetailListQuizTutorial = {
  id: Scalars['String']['output'];
  options: Array<DetailQuizOptionFromDetailListQuizTutorial>;
  question: Scalars['String']['output'];
  radio: Scalars['Boolean']['output'];
  select_box: Scalars['Boolean']['output'];
};

export type DetailQuizOptionFromDetailListQuizTutorial = {
  id: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type DetailQuizTutorialFromDetailTutorial = {
  question_count: Scalars['Int']['output'];
  user_score: Scalars['String']['output'];
  user_status: Scalars['Int']['output'];
};

export type DetailTrackFrPmo = {
  is_verify: Scalars['Int']['output'];
  ready_to_fr: Scalars['Int']['output'];
  redeem_code: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
};

export type DetailTrackQuiz = {
  fr_pmo: DetailTrackFrPmo;
  question_count: Scalars['Int']['output'];
  user_score: Scalars['String']['output'];
  user_status: Scalars['Int']['output'];
};

export type DetailTrackQuizPreTestScore = {
  is_done: Scalars['Int']['output'];
  question_count: Scalars['Int']['output'];
  user_score: Scalars['String']['output'];
  user_status: Scalars['Int']['output'];
};

export type DetailTrackUserProject = {
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  response: Scalars['String']['output'];
  score?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DetailTutorialFromDetailListQuizTutorial = {
  created_at: Scalars['String']['output'];
  description: Scalars['String']['output'];
  has_rating: Scalars['Boolean']['output'];
  icon_url: Scalars['String']['output'];
  id: Scalars['String']['output'];
  in_order: Scalars['Int']['output'];
  info?: Maybe<Scalars['String']['output']>;
  is_hide: Scalars['Int']['output'];
  is_lesson_clear_all: Scalars['Boolean']['output'];
  is_new: Scalars['Int']['output'];
  self_exercise?: Maybe<Scalars['String']['output']>;
  solved_lesson_count: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  total_lesson_count: Scalars['Int']['output'];
  track_id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type DetailTutorialFromDetailTrack = {
  chapter_km?: Maybe<Array<Maybe<DetailChapterFromDetailTutorialKm>>>;
  chapters?: Maybe<Array<Maybe<DetailChapterFromDetailTutorial>>>;
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  fr_pmo?: Maybe<DetailTrackFrPmo>;
  has_already_submit_self_exercise?: Maybe<Scalars['Boolean']['output']>;
  has_self_exercise?: Maybe<Scalars['Boolean']['output']>;
  icon_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  in_order: Scalars['Int']['output'];
  info?: Maybe<Scalars['String']['output']>;
  is_feedback?: Maybe<Scalars['Int']['output']>;
  is_hide?: Maybe<Scalars['Int']['output']>;
  is_lesson_clear_all?: Maybe<Scalars['Boolean']['output']>;
  is_new?: Maybe<Scalars['Int']['output']>;
  is_passed_quiz_tutorial?: Maybe<Scalars['Boolean']['output']>;
  is_tutorial_available?: Maybe<Scalars['Boolean']['output']>;
  mid_exam: Scalars['Boolean']['output'];
  prev_tutorial_title?: Maybe<Scalars['String']['output']>;
  quiz?: Maybe<DetailQuizTutorialFromDetailTutorial>;
  self_exercise?: Maybe<Scalars['String']['output']>;
  self_exercise_attachment?: Maybe<Scalars['String']['output']>;
  self_exercise_deadline?: Maybe<Scalars['String']['output']>;
  self_exercise_feedback?: Maybe<Scalars['String']['output']>;
  self_exercise_score?: Maybe<Scalars['Int']['output']>;
  status_locked?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  track_id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  video_duration?: Maybe<Scalars['Int']['output']>;
  webinar?: Maybe<GetWebinarStatusEntity>;
};

export type DetailUserCertificateResponse = {
  certificate: Certificate;
  track: Track;
  url: Scalars['String']['output'];
  url_image: Scalars['String']['output'];
};

export type FeedbackTpmRequest = {
  attachment_url: Scalars['String']['input'];
  quantitative_score: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  student_id: Scalars['String']['input'];
  tutorial_id: Scalars['String']['input'];
};

export type FeedbackTpmResponse = {
  success: Scalars['Boolean']['output'];
};

export type FeedbackUkRequest = {
  notes: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  status: UserProjectStatus;
  url_file: Scalars['String']['input'];
  user_project_id: Scalars['String']['input'];
};

export type FeedbackUkResponse = {
  success: Scalars['Boolean']['output'];
};

export type FilterMyClass =
  | 'All'
  | 'Done'
  | 'OnProgress';

export type GetAllWebinarStatusEntity = {
  attend: Scalars['Boolean']['output'];
  confirm: Scalars['Boolean']['output'];
  done: Scalars['Boolean']['output'];
  have: Scalars['Int']['output'];
};

export type GetDetailTrackResponse = {
  banner_icon_url: Scalars['String']['output'];
  category: Scalars['Int']['output'];
  certificate_description: Scalars['String']['output'];
  certificate_km_publish?: Maybe<CertificateKmPublish>;
  certificate_modal?: Maybe<CertificateModal>;
  certificate_published: Scalars['String']['output'];
  color: Scalars['String']['output'];
  course_id: Scalars['String']['output'];
  course_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  description_content: Scalars['String']['output'];
  difficulty: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  has_rating: Scalars['Boolean']['output'];
  have_pbl: Scalars['Int']['output'];
  have_pre_test: Scalars['Int']['output'];
  have_project: Scalars['Int']['output'];
  hide: Scalars['Int']['output'];
  icon_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  img?: Maybe<Scalars['String']['output']>;
  is_already_project: Scalars['Boolean']['output'];
  is_already_quiz: Scalars['Boolean']['output'];
  is_free: Scalars['Boolean']['output'];
  last_chapter_activity: Scalars['String']['output'];
  last_tutorial_activity: Scalars['String']['output'];
  lesson_video_count: Scalars['Int']['output'];
  name_of_trainer?: Maybe<Scalars['String']['output']>;
  onboarding_category: Scalars['String']['output'];
  overview?: Maybe<Scalars['String']['output']>;
  pbl_team?: Maybe<PblTeamDetailTrackResponse>;
  percentage_progress: Scalars['Int']['output'];
  poin: Scalars['Int']['output'];
  pre_test?: Maybe<DetailTrackQuizPreTestScore>;
  price: Scalars['Float']['output'];
  publish_set_version?: Maybe<Scalars['Float']['output']>;
  purchased: Scalars['Boolean']['output'];
  quiz?: Maybe<DetailTrackQuiz>;
  rating?: Maybe<Scalars['Float']['output']>;
  self_exercise_count: Scalars['Int']['output'];
  short_description_content: Scalars['String']['output'];
  skkni_kompetensi?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  soal_uk?: Maybe<Scalars['String']['output']>;
  solved_lesson_count: Scalars['Int']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  total_discount?: Maybe<Scalars['String']['output']>;
  total_lesson_count: Scalars['Int']['output'];
  total_price?: Maybe<Scalars['Float']['output']>;
  total_sell?: Maybe<Scalars['Int']['output']>;
  track_category?: Maybe<TrackCategory>;
  trainers?: Maybe<Array<Maybe<Trainer>>>;
  updated_at: Scalars['DateTime']['output'];
  user_project?: Maybe<DetailTrackUserProject>;
  user_project_count: Scalars['Int']['output'];
  video_link?: Maybe<Scalars['String']['output']>;
  webinar?: Maybe<GetAllWebinarStatusEntity>;
  webinar_link?: Maybe<Scalars['String']['output']>;
};

export type GetIsAnyRejectedUserProject = {
  classes: Array<GetIsAnyRejectedUserProjectClass>;
  is_any: Scalars['Boolean']['output'];
};

export type GetIsAnyRejectedUserProjectClass = {
  track: Track;
  url: Scalars['String']['output'];
};

export type GetListFeedbackQuestionKmResponse = {
  created_at: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_hide: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updated_at: Scalars['String']['output'];
};

export type GetListPblTeamMentorDashboard = {
  data: Array<PblTeamListResponse>;
  next_page: Scalars['Int']['output'];
  previous_page: Scalars['Int']['output'];
  total_page: Scalars['Int']['output'];
};

export type GetListPostTestQuizResponse = {
  package: Scalars['String']['output'];
  quiz: Array<Quiz>;
  quiz_preview: QuizPreview;
  track: Track;
};

export type GetListPretestQuizResponse = {
  first_chapter: Chapter;
  package: Scalars['String']['output'];
  quiz: Array<Quiz>;
  track: Track;
  user_score: QuizPreTestScore;
};

export type GetListQuizTutorialResponse = {
  last_chapter?: Maybe<Chapter>;
  package: Scalars['String']['output'];
  quiz_tutorial: Array<Maybe<DetailQuizFromDetailListQuizTutorial>>;
  quiz_tutorial_preview: QuizTutorialPreview;
  track: TrackOnly;
  tutorial: DetailTutorialFromDetailListQuizTutorial;
};

export type GetListTutorialFromDetailTrackResponse = {
  tutorials: Array<Maybe<DetailTutorialFromDetailTrack>>;
};

export type GetTryOutQuizChapterScoreResponse = {
  score: Scalars['Int']['output'];
};

export type GetUserProjectDetailResponse = {
  attachment: Scalars['String']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  project_title: Scalars['String']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  track: Track;
  type: GetUserProjectDetailType;
};

export type GetUserProjectDetailType =
  | 'TutorialSelfExercise'
  | 'TutorialSelfExerciseMidExam'
  | 'UserProject';

export type GetUserProjectListResponse = {
  tutorial_self_exercise: Array<Maybe<TutorialSelfExerciseSubmit>>;
  tutorial_self_exercise_with_mid_exam: Array<Maybe<TutorialSelfExerciseSubmit>>;
  user?: Maybe<User>;
  user_project?: Maybe<UserProject>;
};

export type GetWebinarStatusEntity = {
  attend: Scalars['Boolean']['output'];
  confirm: Scalars['Boolean']['output'];
  date_webinar?: Maybe<Scalars['String']['output']>;
  done: Scalars['Boolean']['output'];
  end_time_webinar?: Maybe<Scalars['String']['output']>;
  have: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  start_time_webinar?: Maybe<Scalars['String']['output']>;
  time_webinar: Scalars['String']['output'];
  url_join: Scalars['String']['output'];
  valid_at?: Maybe<Scalars['String']['output']>;
};

export type GoogleLoginRequest = {
  access_token: Scalars['String']['input'];
};

export type HealthCheckResponse = {
  success: Scalars['Boolean']['output'];
};

export type InsertJoinWebinarRequest = {
  chapter_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
  tutorial_id: Scalars['String']['input'];
  webinar_id: Scalars['String']['input'];
};

export type InsertJoinWebinarResponse = {
  success: Scalars['Boolean']['output'];
};

export type LessonsWithSolvedLesson = {
  chapter_id: Scalars['String']['output'];
  content: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  lesson_content: Scalars['String']['output'];
  lesson_type?: Maybe<Scalars['String']['output']>;
  solved_lesson?: Maybe<SolvedLesson>;
  sorting?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  video_duration?: Maybe<Scalars['Int']['output']>;
};

export type ListLessonFromDetailChapterResponse = {
  last_lesson_index_activity: Scalars['Int']['output'];
  lessons: Array<Maybe<LessonsWithSolvedLesson>>;
};

export type ListPblProjectKmResponse = {
  attachment: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  difficulty: Scalars['String']['output'];
  end_datetime: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  is_selected: Scalars['Boolean']['output'];
  logo_company: Scalars['String']['output'];
  max_quota: Scalars['String']['output'];
  name_company: Scalars['String']['output'];
  pbl_company_profile_id: Scalars['String']['output'];
  quota: Scalars['String']['output'];
  sorting: Scalars['Int']['output'];
  start_datetime: Scalars['DateTime']['output'];
  submission_deadline: Scalars['DateTime']['output'];
  tag: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
  track_id: Scalars['String']['output'];
  tracks_title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LoginRequest = {
  email: Scalars['String']['input'];
  one_signal_player_id?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  voucher_code?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResponse = {
  token: Scalars['String']['output'];
  track: TrackLoginResponse;
  user: User;
};

export type Mutation = {
  answerListFeedbackKM: AnswerListFeedbackKmResponse;
  answerListQuizChapter: AnswerListQuizChapterResponse;
  answerListQuizTutorial: AnswerListQuizTutorialResponse;
  answerPostTestQuiz: AnswerTestQuizResponse;
  answerPretestQuiz: AnswerTestQuizResponse;
  answerQuizChapter: AnswerQuizChapterResponse;
  callbackFR: CallbackFrResponse;
  checkAnswerLessonSPL: CheckAnswerLessonSplResponse;
  checkCode: CheckCodeResponse;
  choosePBLProjectKM: ChoosePblProjectKmResponse;
  feedbackTPM: FeedbackTpmResponse;
  feedbackUK: FeedbackUkResponse;
  healthCheck: HealthCheckResponse;
  insertJoinWebinar: InsertJoinWebinarResponse;
  login: LoginResponse;
  loginWithGoogle: LoginResponse;
  progressLesson: ProgressLessonResponse;
  register: LoginResponse;
  requestFR: RequestFrResponse;
  resendOTP: ResendOtpResponse;
  resetPassword: HealthCheckResponse;
  scoringPBLTeam: ScoringPblTeamResponse;
  sendResetEmailLink: HealthCheckResponse;
  spintarCheckAccountEWallet: SpintarCheckAccountEWalletResponse;
  spintarUpdateEWallet: SpintarGetUserEWalletResponse;
  spintarUploadProof: SpintarUploadProofResponse;
  submitTPM: SubmitTpmResponse;
  submitUK: SubmitUkResponse;
  updateUserPassword: HealthCheckResponse;
  updateUserProfile: AuthGetProfileResponse;
  validateEmail: ValidateEmailResponse;
  verifyOTP: LoginResponse;
};


export type MutationAnswerListFeedbackKmArgs = {
  input: AnswerListFeedbackKmRequest;
};


export type MutationAnswerListQuizChapterArgs = {
  input: AnswerListQuizChapterRequest;
};


export type MutationAnswerListQuizTutorialArgs = {
  input: AnswerListQuizTutorialRequest;
};


export type MutationAnswerPostTestQuizArgs = {
  input: AnswerTestQuizInputRequest;
};


export type MutationAnswerPretestQuizArgs = {
  input: AnswerTestQuizInputRequest;
};


export type MutationAnswerQuizChapterArgs = {
  input: AnswerSingleQuizChapterRequest;
};


export type MutationCallbackFrArgs = {
  request: CallbackFrRequest;
};


export type MutationCheckAnswerLessonSplArgs = {
  input: CheckAnswerLessonSplRequest;
};


export type MutationCheckCodeArgs = {
  input: CheckCodeRequest;
};


export type MutationChoosePblProjectKmArgs = {
  input: ChoosePblProjectKmRequest;
};


export type MutationFeedbackTpmArgs = {
  input: FeedbackTpmRequest;
};


export type MutationFeedbackUkArgs = {
  input: FeedbackUkRequest;
};


export type MutationInsertJoinWebinarArgs = {
  input: InsertJoinWebinarRequest;
};


export type MutationLoginArgs = {
  request: LoginRequest;
};


export type MutationLoginWithGoogleArgs = {
  request: GoogleLoginRequest;
};


export type MutationProgressLessonArgs = {
  input: ProgressLessonRequest;
};


export type MutationRegisterArgs = {
  request: RegisterRequest;
};


export type MutationRequestFrArgs = {
  request: RequestFrRequest;
};


export type MutationResendOtpArgs = {
  request: ResendOtpRequest;
};


export type MutationResetPasswordArgs = {
  request: ResetPasswordRequest;
};


export type MutationScoringPblTeamArgs = {
  input: ScoringPblTeamRequest;
};


export type MutationSendResetEmailLinkArgs = {
  request: SendResetEmailLinkRequest;
};


export type MutationSpintarCheckAccountEWalletArgs = {
  input: SpintarCheckAccountEWalletRequest;
};


export type MutationSpintarUpdateEWalletArgs = {
  input: SpintarUpdateEWalletRequest;
};


export type MutationSpintarUploadProofArgs = {
  file: Scalars['String']['input'];
};


export type MutationSubmitTpmArgs = {
  input: SubmitTpmRequest;
};


export type MutationSubmitUkArgs = {
  input: SubmitUkRequest;
};


export type MutationUpdateUserPasswordArgs = {
  request: UpdateUserPasswordRequest;
};


export type MutationUpdateUserProfileArgs = {
  request: UpdateUserProfileRequest;
};


export type MutationValidateEmailArgs = {
  input: ValidateEmailRequest;
};


export type MutationVerifyOtpArgs = {
  request: VerifyOtpRequest;
};

export type PblCompanyProfileDetailResponse = {
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  header_images: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  website: Scalars['String']['output'];
};

export type PblProjectKmDetailResponse = {
  attachment: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  difficulty: Scalars['String']['output'];
  end_datetime: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  max_quota: Scalars['String']['output'];
  pbl_company_profile_id: Scalars['String']['output'];
  quota: Scalars['String']['output'];
  start_datetime: Scalars['DateTime']['output'];
  submission_deadline: Scalars['DateTime']['output'];
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
  track_id: Scalars['String']['output'];
  tracks_title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PblProjectKmWithPagination = {
  data: Array<ListPblProjectKmResponse>;
  next_page: Scalars['Int']['output'];
  previous_page: Scalars['Int']['output'];
  total_page: Scalars['Int']['output'];
};

export type PblTeamDetailResponse = {
  attachment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  is_best_team: Scalars['Boolean']['output'];
  mentor_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pbl_project_km_id?: Maybe<Scalars['String']['output']>;
  track_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  upload_description?: Maybe<Scalars['String']['output']>;
  uploaded_at?: Maybe<Scalars['DateTime']['output']>;
  user_id_leader?: Maybe<Scalars['String']['output']>;
  user_ids: Array<Scalars['String']['output']>;
  users: Array<UserDetailResponse>;
};

export type PblTeamDetailTrackResponse = {
  attachment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  is_best_team: Scalars['Boolean']['output'];
  mentor_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pbl_project_km_id?: Maybe<Scalars['String']['output']>;
  pbl_team_score?: Maybe<PblTeamScoreDetailResponse>;
  track_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  upload_description?: Maybe<Scalars['String']['output']>;
  uploaded_at?: Maybe<Scalars['DateTime']['output']>;
  user_id_leader?: Maybe<Scalars['String']['output']>;
  user_ids: Array<Scalars['String']['output']>;
  users: Array<UserDetailResponse>;
};

export type PblTeamListResponse = {
  attachment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  is_best_team: Scalars['Boolean']['output'];
  mentor_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pbl_company_profile?: Maybe<PblCompanyProfileDetailResponse>;
  pbl_project_km: PblProjectKmDetailResponse;
  pbl_project_km_id?: Maybe<Scalars['String']['output']>;
  pbl_team_score?: Maybe<PblTeamScoreDetailResponse>;
  track_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  upload_description?: Maybe<Scalars['String']['output']>;
  uploaded_at?: Maybe<Scalars['DateTime']['output']>;
  user_id_leader?: Maybe<Scalars['String']['output']>;
  user_ids: Array<Scalars['String']['output']>;
  users: Array<UserDetailResponse>;
};

export type PblTeamScoreDetailResponse = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  pbl_team_id: Scalars['String']['output'];
  quantitative_score: Scalars['String']['output'];
  score: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PblTeamTrackResponse = {
  attachment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  is_best_team: Scalars['Boolean']['output'];
  mentor_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pbl_project_km?: Maybe<PblProjectKmDetailResponse>;
  pbl_project_km_id?: Maybe<Scalars['String']['output']>;
  pbl_team_score?: Maybe<PblTeamScoreDetailResponse>;
  track_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  upload_description?: Maybe<Scalars['String']['output']>;
  uploaded_at?: Maybe<Scalars['DateTime']['output']>;
  user_id_leader?: Maybe<Scalars['String']['output']>;
  user_ids: Array<Scalars['String']['output']>;
  users: Array<UserDetailResponse>;
};

export type ProgressLessonRequest = {
  chapter_id: Scalars['String']['input'];
  completed_at: Scalars['String']['input'];
  lesson_id: Scalars['String']['input'];
  started_at: Scalars['String']['input'];
};

export type ProgressLessonResponse = {
  chapter_id: Scalars['String']['output'];
  completed_at?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lesson_id: Scalars['String']['output'];
  started_at?: Maybe<Scalars['String']['output']>;
  tmp?: Maybe<Scalars['String']['output']>;
  track_id: Scalars['String']['output'];
  tries: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type Province = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  detailChapter: DetailChapterResponse;
  detailPBLProjectKM: DetailPblProjectKmResponse;
  detailUserCertificate: DetailUserCertificateResponse;
  getAllProvinces: Array<Province>;
  getBitpoinHistoryWithPagination: BitpoinHistoryWithPagination;
  getCitiesByProvinceID: Array<City>;
  getDetailTrack: GetDetailTrackResponse;
  getIsAnyRejectedUserProject: GetIsAnyRejectedUserProject;
  getListFeedbackQuestionKM: Array<GetListFeedbackQuestionKmResponse>;
  getListPBLTeamMentorDashboard: GetListPblTeamMentorDashboard;
  getListPostTestQuiz: GetListPostTestQuizResponse;
  getListPretestQuiz: GetListPretestQuizResponse;
  getListQuizTutorial: GetListQuizTutorialResponse;
  getListStudentMentorDashboard: UserWithPagination;
  getListTutorialFromDetailTrack: GetListTutorialFromDetailTrackResponse;
  getPBLProjectKMWithPagination: PblProjectKmWithPagination;
  getProfile: AuthGetProfileResponse;
  getQuizChapterByChapterID: QuizChapterDetail;
  getSelfExerciseQualitativeTemplate: Array<TutorialSelfExerciseQualitativeScoreCategory>;
  getTracksByTagMentor: Array<Track>;
  getTracksWithPagination: TracksWithPagination;
  getTryOutQuizChapterScore: GetTryOutQuizChapterScoreResponse;
  getUserProjectDetail: GetUserProjectDetailResponse;
  getUserProjectList: GetUserProjectListResponse;
  getUserProjectListMentor: GetUserProjectListResponse;
  healthCheck: HealthCheckResponse;
  listLessonFromDetailChapter: ListLessonFromDetailChapterResponse;
  spintarCheckTheUploadedProof: SpintarCheckTheUploadedProof;
  spintarClassProgressCompleted: SpintarClassProgressCompletedResponse;
  spintarGetAllEWallets: Array<SpintarGetAllEWalletsResponse>;
  spintarGetSpintarResult: SpintarGetSpintarResultResponse;
  spintarGetSpintarTracking: Array<SpintarGetSpintarTrackingResponse>;
  spintarGetUserEWallet: SpintarGetUserEWalletResponse;
  spintarIsBlacklistedUser: SpintarIsBlacklistedUserResponse;
  spintarTotalTransactionTracks: SpintarTotalTransactionTracksResponse;
  spintarWheelData: SpintarWheelDataResponse;
  spintarWheelResult: SpintarWheelResultDataResponse;
  statusRedeem: StatusRedeemResponse;
  userProjectFixDataFromPMO: HealthCheckResponse;
};


export type QueryDetailChapterArgs = {
  chapter_id: Scalars['String']['input'];
};


export type QueryDetailPblProjectKmArgs = {
  id: Scalars['String']['input'];
};


export type QueryDetailUserCertificateArgs = {
  certificateType: CertificateType;
  slug: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
};


export type QueryGetBitpoinHistoryWithPaginationArgs = {
  current_page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy: BitpoinSortBy;
};


export type QueryGetCitiesByProvinceIdArgs = {
  province_id: Scalars['String']['input'];
};


export type QueryGetDetailTrackArgs = {
  my_track: Scalars['Boolean']['input'];
  track_id: Scalars['String']['input'];
};


export type QueryGetListPblTeamMentorDashboardArgs = {
  current_page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
  track_id: Scalars['String']['input'];
  type: UserMentorDashboardRequest;
};


export type QueryGetListPostTestQuizArgs = {
  track_id: Scalars['String']['input'];
};


export type QueryGetListPretestQuizArgs = {
  track_id: Scalars['String']['input'];
};


export type QueryGetListQuizTutorialArgs = {
  tutorial_id: Scalars['String']['input'];
};


export type QueryGetListStudentMentorDashboardArgs = {
  current_page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
  track_id: Scalars['String']['input'];
  type: UserMentorDashboardRequest;
};


export type QueryGetListTutorialFromDetailTrackArgs = {
  my_track: Scalars['Boolean']['input'];
  track_id: Scalars['String']['input'];
};


export type QueryGetPblProjectKmWithPaginationArgs = {
  current_page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
  track_id: Scalars['String']['input'];
};


export type QueryGetQuizChapterByChapterIdArgs = {
  chapter_id: Scalars['String']['input'];
};


export type QueryGetSelfExerciseQualitativeTemplateArgs = {
  tutorial_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTracksWithPaginationArgs = {
  course_type: TrackCourseType;
  current_page: Scalars['Int']['input'];
  filter_my_class?: InputMaybe<FilterMyClass>;
  get_certificate?: InputMaybe<Scalars['Boolean']['input']>;
  my_class: Scalars['Boolean']['input'];
  page_size: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy: TrackCourseSortBy;
};


export type QueryGetTryOutQuizChapterScoreArgs = {
  tutorial_id: Scalars['String']['input'];
};


export type QueryGetUserProjectDetailArgs = {
  id: Scalars['String']['input'];
  type: GetUserProjectDetailType;
};


export type QueryGetUserProjectListArgs = {
  status: UserProjectStatus;
  track_id: Scalars['String']['input'];
};


export type QueryGetUserProjectListMentorArgs = {
  student_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};


export type QueryListLessonFromDetailChapterArgs = {
  chapter_id: Scalars['String']['input'];
};

export type Quiz = {
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  media?: Maybe<Scalars['String']['output']>;
  options: Array<QuizOption>;
  package?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  track_id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type QuizChapter = {
  chapter: Chapter;
  chapter_id: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  media?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  quiz_chapter_options: Array<QuizChapterOption>;
  quiz_type: Scalars['String']['output'];
  track: Track;
  tutorial: Tutorial;
  updated_at: Scalars['String']['output'];
};

export type QuizChapterDetail = {
  expired_at: Scalars['String']['output'];
  quiz_chapter: Array<Maybe<QuizChapter>>;
};

export type QuizChapterOption = {
  created_at: Scalars['String']['output'];
  id: Scalars['String']['output'];
  option: Scalars['String']['output'];
  quiz_chapter_id: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type QuizOption = {
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  option: Scalars['String']['output'];
  quiz_id: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type QuizPreTestScore = {
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  is_done: Scalars['Int']['output'];
  package?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  track_id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['String']['output'];
};

export type QuizPreview = {
  is_allow_post_test: Scalars['Boolean']['output'];
  is_available_for_post_test: Scalars['Int']['output'];
  min_score: Scalars['Int']['output'];
  post_test_message: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  total_question: Scalars['Int']['output'];
};

export type QuizTutorialPreview = {
  min_score: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  total_question: Scalars['Int']['output'];
};

export type RegisterRequest = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  referral_code?: InputMaybe<Scalars['String']['input']>;
  via: Scalars['String']['input'];
  voucher_code?: InputMaybe<Scalars['String']['input']>;
};

export type RequestFrRequest = {
  code: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  voucher_code: Scalars['String']['input'];
};

export type RequestFrResponse = {
  data?: Maybe<Scalars['Any']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResendOtpRequest = {
  via: Scalars['String']['input'];
};

export type ResendOtpResponse = {
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordRequest = {
  new_password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ScoringPblTeamRequest = {
  pbl_team_id: Scalars['String']['input'];
  quantitative_score: Scalars['String']['input'];
  score: Scalars['String']['input'];
};

export type ScoringPblTeamResponse = {
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  pbl_team: PblTeamDetailResponse;
  pbl_team_id: Scalars['String']['output'];
  quantitative_score: Scalars['String']['output'];
  score: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type SendResetEmailLinkRequest = {
  email: Scalars['String']['input'];
};

export type SolvedLesson = {
  chapter_id: Scalars['String']['output'];
  completed_at: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lesson_id: Scalars['String']['output'];
  started_at: Scalars['String']['output'];
  tmp?: Maybe<Scalars['String']['output']>;
  track_id: Scalars['String']['output'];
  tries: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_id: Scalars['String']['output'];
};

export type SpintarCheckAccountEWalletRequest = {
  account_number: Scalars['String']['input'];
  ewallet_id: Scalars['Int']['input'];
};

export type SpintarCheckAccountEWalletResponse = {
  account_name: Scalars['String']['output'];
  account_number: Scalars['String']['output'];
  ewallet: SpintarGetAllEWalletsResponse;
  ewallet_id: Scalars['Int']['output'];
};

export type SpintarCheckTheUploadedProof = {
  attachment: Scalars['String']['output'];
  is_uploaded: Scalars['Boolean']['output'];
  upload_time: Scalars['String']['output'];
};

export type SpintarClassProgressCompletedResponse = {
  completed: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
  need_completed: Scalars['Int']['output'];
};

export type SpintarGetAllEWalletsResponse = {
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SpintarGetSpintarResultResponse = {
  id: Scalars['String']['output'];
  nominal: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type SpintarGetSpintarTrackingResponse = {
  description_wording: Scalars['String']['output'];
  id: Scalars['String']['output'];
  spintar_result_id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title_wording: Scalars['String']['output'];
};

export type SpintarGetUserEWalletResponse = {
  account_name: Scalars['String']['output'];
  account_number: Scalars['String']['output'];
  ewallet: SpintarGetAllEWalletsResponse;
  ewallet_id: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type SpintarIsBlacklistedUserResponse = {
  blacklisted: Scalars['Boolean']['output'];
};

export type SpintarTotalTransactionTracksResponse = {
  benefits: Array<Benefits>;
  total_transactions: Scalars['Float']['output'];
};

export type SpintarUpdateEWalletRequest = {
  account_number: Scalars['String']['input'];
  ewallet_id: Scalars['Int']['input'];
};

export type SpintarUploadProofResponse = {
  url_endpoint: Scalars['String']['output'];
};

export type SpintarWheelDataResponse = {
  data: Array<Scalars['Int']['output']>;
};

export type SpintarWheelResultDataResponse = {
  data: Scalars['Int']['output'];
};

export type StatusRedeemResponse = {
  data?: Maybe<Scalars['Any']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubmitTpmRequest = {
  attachment: Scalars['Base64']['input'];
  tutorial_id: Scalars['String']['input'];
};

export type SubmitTpmResponse = {
  attachment: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['String']['output'];
  tutorial_id: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type SubmitUkRequest = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  image: Scalars['Base64']['input'];
  name: Scalars['String']['input'];
};

export type SubmitUkResponse = {
  category: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  is_archived: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  repository_link?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  score_char?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type Track = {
  bannerIconURL: Scalars['String']['output'];
  category: Scalars['Int']['output'];
  certificateDescription: Scalars['String']['output'];
  color: Scalars['String']['output'];
  courseID: Scalars['String']['output'];
  courseType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  descriptionContent: Scalars['String']['output'];
  detail_user_certificate?: Maybe<DetailUserCertificateResponse>;
  difficulty: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  havePBL: Scalars['Int']['output'];
  havePreTest: Scalars['Int']['output'];
  haveProject: Scalars['Int']['output'];
  hide: Scalars['Int']['output'];
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  img?: Maybe<Scalars['String']['output']>;
  isFree: Scalars['Boolean']['output'];
  nameOfTrainer?: Maybe<Scalars['String']['output']>;
  onboardingCategory: Scalars['String']['output'];
  overview?: Maybe<Scalars['String']['output']>;
  pbl_team?: Maybe<PblTeamTrackResponse>;
  percentage_progress: Scalars['Int']['output'];
  poin: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  publishSetVersion?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  self_exercise_count: Scalars['Int']['output'];
  shortDescriptionContent: Scalars['String']['output'];
  skkniKompetensi?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  soalUK?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  total_discount?: Maybe<Scalars['String']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  total_sell?: Maybe<Scalars['Int']['output']>;
  track_category?: Maybe<TrackCategory>;
  updatedAt: Scalars['String']['output'];
  user_project_count: Scalars['Int']['output'];
  videoLink?: Maybe<Scalars['String']['output']>;
  webinarLink?: Maybe<Scalars['String']['output']>;
};

export type TrackCategory = {
  category: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type TrackCourseSortBy =
  | 'BestSeller'
  | 'Interesting'
  | 'Newest'
  | 'TopRated';

export type TrackCourseType =
  | 'All'
  | 'Daring'
  | 'KampusMerdeka'
  | 'SPL'
  | 'Yes';

export type TrackLoginResponse = {
  id: Scalars['String']['output'];
  referral_code: Scalars['String']['output'];
  title: Scalars['String']['output'];
  voucher_code: Scalars['String']['output'];
};

export type TrackOnly = {
  bannerIconURL: Scalars['String']['output'];
  category: Scalars['Int']['output'];
  certificateDescription: Scalars['String']['output'];
  color: Scalars['String']['output'];
  courseID: Scalars['String']['output'];
  courseType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  descriptionContent: Scalars['String']['output'];
  difficulty: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  havePBL: Scalars['Int']['output'];
  havePreTest: Scalars['Int']['output'];
  haveProject: Scalars['Int']['output'];
  hide: Scalars['Int']['output'];
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  img?: Maybe<Scalars['String']['output']>;
  isFree: Scalars['Boolean']['output'];
  nameOfTrainer?: Maybe<Scalars['String']['output']>;
  onboardingCategory: Scalars['String']['output'];
  overview?: Maybe<Scalars['String']['output']>;
  poin: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  publishSetVersion?: Maybe<Scalars['Float']['output']>;
  shortDescriptionContent: Scalars['String']['output'];
  skkniKompetensi?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  soalUK?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  videoLink?: Maybe<Scalars['String']['output']>;
  webinarLink?: Maybe<Scalars['String']['output']>;
};

export type TracksWithPagination = {
  data: Array<Track>;
  next_page: Scalars['Int']['output'];
  previous_page: Scalars['Int']['output'];
  total_page: Scalars['Int']['output'];
};

export type Trainer = {
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  track_id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Tutorial = {
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  iconURL: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inOrder: Scalars['Int']['output'];
  info?: Maybe<Scalars['String']['output']>;
  isFeedback: Scalars['Int']['output'];
  isHide: Scalars['Int']['output'];
  isNew: Scalars['Int']['output'];
  midExam: Scalars['Int']['output'];
  selfExercise?: Maybe<Scalars['String']['output']>;
  selfExerciseDeadline?: Maybe<Scalars['String']['output']>;
  statusLocked: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  trackID: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TutorialSelfExerciseQualitativeScoreCategory = {
  created_at: Scalars['String']['output'];
  id: Scalars['String']['output'];
  max_score: Scalars['Int']['output'];
  min_score: Scalars['Int']['output'];
  qualitative_score: Scalars['String']['output'];
  tutorial_id: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type TutorialSelfExerciseQuantitativeScore = {
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  quantitativeScore: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  tutorialID: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userID: Scalars['String']['output'];
};

export type TutorialSelfExerciseSubmit = {
  attachment: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  feedback_user_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  need_review?: Maybe<Scalars['Boolean']['output']>;
  quantitativeScore?: Maybe<TutorialSelfExerciseQuantitativeScore>;
  track: Track;
  tutorial: Tutorial;
  tutorialID: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userID: Scalars['String']['output'];
};

export type UpdateUserPasswordRequest = {
  new_password: Scalars['String']['input'];
  old_password: Scalars['String']['input'];
};

export type UpdateUserProfileRequest = {
  address: Scalars['String']['input'];
  age: Scalars['String']['input'];
  domisili: Scalars['Int']['input'];
  gender: UserGender;
  name: Scalars['String']['input'];
  name_on_certificate: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  province_id: Scalars['Int']['input'];
};

export type User = {
  access_type: UserAccessType;
  address?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  coding_experience?: Maybe<Scalars['String']['output']>;
  confirmation: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  date_open_page_sub_package?: Maybe<Scalars['Int']['output']>;
  domisili?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  facebook?: Maybe<Scalars['String']['output']>;
  facebook_user_id?: Maybe<Scalars['String']['output']>;
  fb_pixel?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  goal: UserGoal;
  google_user_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  instagram_selling_acc?: Maybe<Scalars['String']['output']>;
  is_online_selling?: Maybe<Scalars['Boolean']['output']>;
  learning?: Maybe<Scalars['String']['output']>;
  linked_in?: Maybe<Scalars['String']['output']>;
  marketplace_acc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  name_on_certificate?: Maybe<Scalars['String']['output']>;
  online_selling_website?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  province_id?: Maybe<Scalars['Int']['output']>;
  ref_id?: Maybe<Scalars['String']['output']>;
  role: Scalars['Int']['output'];
  selling_desc?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type UserAccessType =
  | 'DUMMY'
  | 'LIVE';

export type UserDetailResponse = {
  avatar: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserGender =
  | 'L'
  | 'P';

export type UserGoal =
  | 'AMBITIOUS'
  | 'CASUAL'
  | 'INSANE';

export type UserMentorDashboardRequest =
  | 'UserMentorDashboardRequestKMFinalProjectReviewed'
  | 'UserMentorDashboardRequestKMFinalProjectToReview'
  | 'UserMentorDashboardRequestKMHandsOnMidExamReviewed'
  | 'UserMentorDashboardRequestKMHandsOnMidExamToReview'
  | 'UserMentorDashboardRequestKMHandsOnReviewed'
  | 'UserMentorDashboardRequestKMHandsOnToReview';

export type UserProject = {
  category: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  isArchived: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  need_review?: Maybe<Scalars['Boolean']['output']>;
  repositoryLink?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  scoreChar?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  track: Track;
  updatedAt: Scalars['String']['output'];
  userID: Scalars['ID']['output'];
};

export type UserProjectStatus =
  | 'All'
  | 'Passed'
  | 'Rejected'
  | 'ReviewWaiting'
  | 'Revision';

export type UserWithPagination = {
  data: Array<User>;
  next_page: Scalars['Int']['output'];
  previous_page: Scalars['Int']['output'];
  total_page: Scalars['Int']['output'];
};

export type ValidateEmailRequest = {
  email: Scalars['String']['input'];
};

export type ValidateEmailResponse = {
  success: Scalars['Boolean']['output'];
};

export type VerifyOtpRequest = {
  otp: Scalars['String']['input'];
};

export type LoginMutationVariables = Exact<{
  request: LoginRequest;
}>;


export type LoginMutation = { login: { token: string, user: { id: string, name: string, email: string, role: number, confirmation: boolean } } };

export type RegisterMutationVariables = Exact<{
  request: RegisterRequest;
}>;


export type RegisterMutation = { register: { token: string, user: { id: string, name: string, email: string, role: number } } };

export type ResendOtpMutationVariables = Exact<{
  req: ResendOtpRequest;
}>;


export type ResendOtpMutation = { resendOTP: { success: boolean } };

export type VerifyOtpMutationVariables = Exact<{
  req: VerifyOtpRequest;
}>;


export type VerifyOtpMutation = { verifyOTP: { token: string, user: { id: string, name: string, email: string, phone?: string | null, access_type: UserAccessType } } };

export type LoginGoogleMutationVariables = Exact<{
  req: GoogleLoginRequest;
}>;


export type LoginGoogleMutation = { loginWithGoogle: { token: string, user: { id: string, name: string, email: string, role: number, confirmation: boolean } } };

export type AuthForgotPasswordMutationVariables = Exact<{
  req: SendResetEmailLinkRequest;
}>;


export type AuthForgotPasswordMutation = { sendResetEmailLink: { success: boolean } };

export type AuthNewPasswordMutationVariables = Exact<{
  req: ResetPasswordRequest;
}>;


export type AuthNewPasswordMutation = { resetPassword: { success: boolean } };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { getProfile: { is_need_update_profile: boolean, profile: { id: string, name: string, email: string, role: number, phone?: string | null, confirmation: boolean } } };

export type TrackDetailsQueryVariables = Exact<{
  trackId: Scalars['String']['input'];
  myTrack: Scalars['Boolean']['input'];
}>;


export type TrackDetailsQuery = { getDetailTrack: { id: string, title: string, banner_icon_url: string, description_content: string, difficulty: string, onboarding_category: string, short_description_content: string, overview?: string | null, img?: string | null, price: number, discount: number, is_free: boolean, tag?: string | null, webinar_link?: string | null, name_of_trainer?: string | null, duration?: string | null, course_type?: string | null, rating?: number | null, total_sell?: number | null, total_price?: number | null, total_discount?: string | null, percentage_progress: number, self_exercise_count: number, user_project_count: number, purchased: boolean, solved_lesson_count: number, total_lesson_count: number, lesson_video_count: number, last_chapter_activity: string, last_tutorial_activity: string, has_rating: boolean, is_already_project: boolean, is_already_quiz: boolean, track_category?: { id: number, category: string } | null, trainers?: Array<{ image?: string | null, name?: string | null, job?: string | null, description?: string | null } | null> | null, quiz?: { question_count: number, user_score: string, user_status: number, fr_pmo: { redeem_code: string, sequence: number, is_verify: number, ready_to_fr: number } } | null }, getListTutorialFromDetailTrack: { tutorials: Array<{ id: string, track_id: string, title: string, description: string, type: string, video_duration?: number | null, mid_exam: boolean, has_self_exercise?: boolean | null, has_already_submit_self_exercise?: boolean | null, self_exercise?: string | null, self_exercise_deadline?: string | null, self_exercise_attachment?: string | null, self_exercise_score?: number | null, self_exercise_feedback?: string | null, is_feedback?: number | null, chapters?: Array<{ id: string, tutorial_id: string, title: string, status: string, lesson_video_count: number, total_lesson_count: number, solved_lesson_count: number, chapter_type: string, duration_quiz_countdown?: number | null, guide?: string | null, attempt?: number | null, quiz_score?: number | null } | null> | null, chapter_km?: Array<{ id: string, title: string, chapter_type: string, lesson_video_count: number, total_lesson_count: number, solved_lesson_count: number, quiz_status?: number | null, total_quiz_count?: number | null, quiz_score?: number | null, status: string, attempt?: number | null, webinar?: { id: string, done: boolean, url_join: string, start_time_webinar?: string | null, end_time_webinar?: string | null, attend: boolean, valid_at?: string | null, confirm: boolean } | null } | null> | null, quiz?: { question_count: number, user_score: string, user_status: number } | null } | null> } };

export type TrackQuizQueryVariables = Exact<{
  chapterId: Scalars['String']['input'];
}>;


export type TrackQuizQuery = { getQuizChapterByChapterID: { expired_at: string, quiz_chapter: Array<{ id: string, question: string, chapter_id: string, package?: string | null, media?: string | null, quiz_type: string, quiz_chapter_options: Array<{ id: string, option: string, quiz_chapter_id: string }>, chapter: { id: string, title: string, duration_quiz_countdown?: number | null, guide?: string | null }, tutorial: { id: string, title: string }, track: { id: string } } | null> } };

export type TrackQuizCheckAnswerMutationVariables = Exact<{
  req: AnswerSingleQuizChapterRequest;
}>;


export type TrackQuizCheckAnswerMutation = { answerQuizChapter: { is_correct: boolean, explanation?: string | null } };

export type TrackQuizCheckAnswerBatchMutationVariables = Exact<{
  req: AnswerListQuizChapterRequest;
}>;


export type TrackQuizCheckAnswerBatchMutation = { answerListQuizChapter: { condition: string, score: number, total_benar: number, total_salah: number, min_score: number } };

export type GetTracksWithPaginationQueryVariables = Exact<{
  filterMyClass: FilterMyClass;
  myClass: Scalars['Boolean']['input'];
}>;


export type GetTracksWithPaginationQuery = { getTracksWithPagination: { total_page: number, previous_page: number, next_page: number, data: Array<{ id: string, title: string, iconURL?: string | null, img?: string | null, bannerIconURL: string, price: number, discount: number, isFree: boolean, tag?: string | null, courseType?: string | null, rating?: number | null, total_sell?: number | null, total_price?: number | null, total_discount?: string | null, percentage_progress: number, track_category?: { id: number, category: string } | null }> } };

export type TrackLessonListQueryVariables = Exact<{
  chapterId: Scalars['String']['input'];
}>;


export type TrackLessonListQuery = { listLessonFromDetailChapter: { last_lesson_index_activity: number, lessons: Array<{ id: string, chapter_id: string, sorting?: number | null, title: string, image_url?: string | null, content: string, lesson_content: string, type: string, lesson_type?: string | null, video_duration?: number | null, created_at: unknown, updated_at: unknown, solved_lesson?: { id: string, completed_at: string } | null } | null> } };

export type TrackLessonMarkAsCompleteMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  lessonId: Scalars['String']['input'];
  completedAt: Scalars['String']['input'];
  startedAt: Scalars['String']['input'];
}>;


export type TrackLessonMarkAsCompleteMutation = { progressLesson: { id: string, user_id: string, lesson_id: string, chapter_id: string, track_id: string, started_at?: string | null, completed_at?: string | null, tries: number, created_at?: string | null, updated_at?: string | null, tmp?: string | null } };

export type InsertJoinWebinarMutationVariables = Exact<{
  req: InsertJoinWebinarRequest;
}>;


export type InsertJoinWebinarMutation = { insertJoinWebinar: { success: boolean } };

export type GetTryOutQuizChapterScoreQueryVariables = Exact<{
  tutorialId: Scalars['String']['input'];
}>;


export type GetTryOutQuizChapterScoreQuery = { getTryOutQuizChapterScore: { score: number } };

export type SubmitTpmMutationVariables = Exact<{
  req: SubmitTpmRequest;
}>;


export type SubmitTpmMutation = { submitTPM: { id: string, user_id: string, tutorial_id: string, attachment: string, created_at: string, updated_at: string } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any> | undefined) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const LoginDocument = new TypedDocumentString(`
    mutation Login($request: LoginRequest!) {
  login(request: $request) {
    token
    user {
      id
      name
      email
      role
      confirmation
    }
  }
}
    `) as unknown as TypedDocumentString<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = new TypedDocumentString(`
    mutation Register($request: RegisterRequest!) {
  register(request: $request) {
    token
    user {
      id
      name
      email
      role
    }
  }
}
    `) as unknown as TypedDocumentString<RegisterMutation, RegisterMutationVariables>;
export const ResendOtpDocument = new TypedDocumentString(`
    mutation ResendOtp($req: ResendOTPRequest!) {
  resendOTP(request: $req) {
    success
  }
}
    `) as unknown as TypedDocumentString<ResendOtpMutation, ResendOtpMutationVariables>;
export const VerifyOtpDocument = new TypedDocumentString(`
    mutation VerifyOTP($req: VerifyOTPRequest!) {
  verifyOTP(request: $req) {
    token
    user {
      id
      name
      email
      phone
      access_type
    }
  }
}
    `) as unknown as TypedDocumentString<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const LoginGoogleDocument = new TypedDocumentString(`
    mutation LoginGoogle($req: GoogleLoginRequest!) {
  loginWithGoogle(request: $req) {
    token
    user {
      id
      name
      email
      role
      confirmation
    }
  }
}
    `) as unknown as TypedDocumentString<LoginGoogleMutation, LoginGoogleMutationVariables>;
export const AuthForgotPasswordDocument = new TypedDocumentString(`
    mutation AuthForgotPassword($req: SendResetEmailLinkRequest!) {
  sendResetEmailLink(request: $req) {
    success
  }
}
    `) as unknown as TypedDocumentString<AuthForgotPasswordMutation, AuthForgotPasswordMutationVariables>;
export const AuthNewPasswordDocument = new TypedDocumentString(`
    mutation AuthNewPassword($req: ResetPasswordRequest!) {
  resetPassword(request: $req) {
    success
  }
}
    `) as unknown as TypedDocumentString<AuthNewPasswordMutation, AuthNewPasswordMutationVariables>;
export const GetProfileDocument = new TypedDocumentString(`
    query GetProfile {
  getProfile {
    is_need_update_profile
    profile {
      id
      name
      email
      role
      phone
      confirmation
    }
  }
}
    `) as unknown as TypedDocumentString<GetProfileQuery, GetProfileQueryVariables>;
export const TrackDetailsDocument = new TypedDocumentString(`
    query TrackDetails($trackId: String!, $myTrack: Boolean!) {
  getDetailTrack(track_id: $trackId, my_track: $myTrack) {
    id
    title
    banner_icon_url
    description_content
    difficulty
    onboarding_category
    short_description_content
    overview
    img
    price
    discount
    is_free
    tag
    webinar_link
    name_of_trainer
    duration
    course_type
    rating
    total_sell
    total_price
    total_discount
    percentage_progress
    self_exercise_count
    user_project_count
    purchased
    solved_lesson_count
    total_lesson_count
    lesson_video_count
    last_chapter_activity
    last_tutorial_activity
    has_rating
    track_category {
      id
      category
    }
    trainers {
      image
      name
      job
      description
    }
    quiz {
      question_count
      user_score
      user_status
      fr_pmo {
        redeem_code
        sequence
        is_verify
        ready_to_fr
      }
    }
    is_already_project
    is_already_quiz
  }
  getListTutorialFromDetailTrack(track_id: $trackId, my_track: $myTrack) {
    tutorials {
      id
      track_id
      title
      description
      type
      video_duration
      mid_exam
      has_self_exercise
      has_already_submit_self_exercise
      self_exercise
      self_exercise_deadline
      self_exercise_attachment
      self_exercise_score
      self_exercise_feedback
      is_feedback
      chapters {
        id
        tutorial_id
        title
        status
        lesson_video_count
        total_lesson_count
        solved_lesson_count
        chapter_type
        duration_quiz_countdown
        guide
        attempt
        quiz_score
      }
      chapter_km {
        id
        title
        chapter_type
        lesson_video_count
        total_lesson_count
        solved_lesson_count
        quiz_status
        total_quiz_count
        quiz_score
        status
        attempt
        webinar {
          id
          done
          url_join
          start_time_webinar
          end_time_webinar
          attend
          valid_at
          confirm
        }
      }
      quiz {
        question_count
        user_score
        user_status
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TrackDetailsQuery, TrackDetailsQueryVariables>;
export const TrackQuizDocument = new TypedDocumentString(`
    query TrackQuiz($chapterId: String!) {
  getQuizChapterByChapterID(chapter_id: $chapterId) {
    expired_at
    quiz_chapter {
      id
      question
      chapter_id
      package
      media
      quiz_type
      quiz_chapter_options {
        id
        option
        quiz_chapter_id
      }
      chapter {
        id
        title
        duration_quiz_countdown
        guide
      }
      tutorial {
        id
        title
      }
      track {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TrackQuizQuery, TrackQuizQueryVariables>;
export const TrackQuizCheckAnswerDocument = new TypedDocumentString(`
    mutation TrackQuizCheckAnswer($req: AnswerSingleQuizChapterRequest!) {
  answerQuizChapter(input: $req) {
    is_correct
    explanation
  }
}
    `) as unknown as TypedDocumentString<TrackQuizCheckAnswerMutation, TrackQuizCheckAnswerMutationVariables>;
export const TrackQuizCheckAnswerBatchDocument = new TypedDocumentString(`
    mutation TrackQuizCheckAnswerBatch($req: AnswerListQuizChapterRequest!) {
  answerListQuizChapter(input: $req) {
    condition
    score
    total_benar
    total_salah
    min_score
  }
}
    `) as unknown as TypedDocumentString<TrackQuizCheckAnswerBatchMutation, TrackQuizCheckAnswerBatchMutationVariables>;
export const GetTracksWithPaginationDocument = new TypedDocumentString(`
    query GetTracksWithPagination($filterMyClass: FilterMyClass!, $myClass: Boolean!) {
  getTracksWithPagination(
    course_type: Yes
    current_page: 1
    filter_my_class: $filterMyClass
    my_class: $myClass
    get_certificate: false
    search: ""
    sortBy: Newest
    page_size: 10
  ) {
    total_page
    previous_page
    next_page
    data {
      id
      title
      iconURL
      img
      bannerIconURL
      price
      discount
      isFree
      tag
      courseType
      rating
      total_sell
      total_price
      track_category {
        id
        category
      }
      total_discount
      percentage_progress
    }
  }
}
    `) as unknown as TypedDocumentString<GetTracksWithPaginationQuery, GetTracksWithPaginationQueryVariables>;
export const TrackLessonListDocument = new TypedDocumentString(`
    query TrackLessonList($chapterId: String!) {
  listLessonFromDetailChapter(chapter_id: $chapterId) {
    lessons {
      id
      chapter_id
      sorting
      title
      image_url
      content
      lesson_content
      type
      lesson_type
      video_duration
      created_at
      updated_at
      solved_lesson {
        id
        completed_at
      }
    }
    last_lesson_index_activity
  }
}
    `) as unknown as TypedDocumentString<TrackLessonListQuery, TrackLessonListQueryVariables>;
export const TrackLessonMarkAsCompleteDocument = new TypedDocumentString(`
    mutation TrackLessonMarkAsComplete($chapterId: String!, $lessonId: String!, $completedAt: String!, $startedAt: String!) {
  progressLesson(
    input: {chapter_id: $chapterId, lesson_id: $lessonId, completed_at: $completedAt, started_at: $startedAt}
  ) {
    id
    user_id
    lesson_id
    chapter_id
    track_id
    started_at
    completed_at
    tries
    created_at
    updated_at
    tmp
  }
}
    `) as unknown as TypedDocumentString<TrackLessonMarkAsCompleteMutation, TrackLessonMarkAsCompleteMutationVariables>;
export const InsertJoinWebinarDocument = new TypedDocumentString(`
    mutation InsertJoinWebinar($req: InsertJoinWebinarRequest!) {
  insertJoinWebinar(input: $req) {
    success
  }
}
    `) as unknown as TypedDocumentString<InsertJoinWebinarMutation, InsertJoinWebinarMutationVariables>;
export const GetTryOutQuizChapterScoreDocument = new TypedDocumentString(`
    query GetTryOutQuizChapterScore($tutorialId: String!) {
  getTryOutQuizChapterScore(tutorial_id: $tutorialId) {
    score
  }
}
    `) as unknown as TypedDocumentString<GetTryOutQuizChapterScoreQuery, GetTryOutQuizChapterScoreQueryVariables>;
export const SubmitTpmDocument = new TypedDocumentString(`
    mutation SubmitTpm($req: SubmitTPMRequest!) {
  submitTPM(input: $req) {
    id
    user_id
    tutorial_id
    attachment
    created_at
    updated_at
  }
}
    `) as unknown as TypedDocumentString<SubmitTpmMutation, SubmitTpmMutationVariables>;